module.exports = __webpack_public_path__ + "media/images/aicomposz-logo-HighRes-Black-Trans-a0c88697.png";